<div class="table-responsive text-left">
  <table class="table table-bordered" *ngIf="(settingState | async).subscriptionItems !== null">
    <thead>
    <tr>
      <th>Status</th>
      <th>Date</th>
      <th>Amount</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let item of (settingState | async).subscriptionItems">
      <td class="text-capitalize">{{item.status}}</td>
      <td>{{(item.created_at * 1000) | date:'short'}}</td>
      <td>
      <span *ngIf="item.order !== undefined">
        {{item.order.amount}} $
      </span>
        <span *ngIf="item.order === undefined">
        ---
      </span>
      </td>
    </tr>
    </tbody>
  </table>

</div>
